import axios from 'axios';
import getEnvVars from '../../env';
import { errHandler } from '../errHandler';
import { PlayerNotificationProps, PollCampaignGoalProps, PollCampaignLeaderProps, PollCampaignProps, PollOptionProps, PollProps, PollResponseProps } from '../types/auth_svc';
import { player_getBulkPlayers } from './player';
import { V1_LOAD_ALERT, V1_UPDATE_POLLS, V1_UPDATE_POLL_CAMPAIGNS, V1_UPDATE_POLL_CAMPAIGN_GOALS, V1_UPDATE_POLL_CAMPAIGN_LEADERS, V1_UPDATE_POLL_OPTIONS, V1_UPDATE_POLL_SUMMARIES } from './types';
const { AUTH_SVC_API } = getEnvVars()


export const poll_createPollCampaign = (poll_campaign:PollCampaignProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/create`, { poll_campaign })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: [ resp.data.poll_campaign ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_getPollCampaignById = (poll_campaign_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/${poll_campaign_id}`)
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: [resp.data.poll_campaign] })
        } catch (e) {
            console.log(e)
        }
    }
}
//GOALS ------
export const poll_getPollCampaignGoalById = (poll_campaign_goal_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/goals/goal/${poll_campaign_goal_id}`)
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGN_GOALS, poll_campaign_goals: [resp.data.poll_campaign_goal] })
        } catch (e) {
            console.log(e)
        }
    }
}

export const poll_createPollCampaignGoal = (poll_campaign_goal:PollCampaignGoalProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/goals/goal/create`, { poll_campaign_goal })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGN_GOALS, poll_campaign_goals: [resp.data.poll_campaign_goal] })
        } catch (e) {
            console.log(e)
        }
    }
}

export const poll_updatePollCampaignGoal = (poll_campaign_goal:PollCampaignGoalProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/goals/goal/update`, { poll_campaign_goal })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGN_GOALS, poll_campaign_goals: [resp.data.poll_campaign_goal] })
        } catch (e) {
            console.log(e)
        }
    }
}

//----

export const poll_updatePollCampaign = (poll_campaign:PollCampaignProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/update`, { poll_campaign })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: [ resp.data.poll_campaign ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_closePollCampaign = (poll_campaign_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/close`, { poll_campaign_id })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: [ resp.data.poll_campaign ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_copyPollCampaign = (poll_campaign_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/copy`, { poll_campaign_id })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: [ resp.data.poll_campaign ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_archivePollCampaign = (poll_campaign_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/archive`, { poll_campaign_id })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: [ resp.data.poll_campaign ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_deletePollCampaign = (poll_campaign_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/delete`, { poll_campaign_id })
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: [ resp.data.poll_campaign ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_getPollCampaignsByPlayerId = (player_id:string, offset:number, status?:string) => {
    return async(dispatch:any) => {
        try {
           const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/campaigns/player/${player_id}?offset=${offset}&status=${status}`)
           dispatch({ type: V1_UPDATE_POLL_CAMPAIGNS, poll_campaigns: resp.data.poll_campaigns })
        } catch (e) {
            console.log(e)
        }
    }
}

export const poll_createPoll = (poll:PollProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/create`, { poll })
            dispatch({ type: V1_UPDATE_POLLS, polls: [ resp.data.poll ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_updatePoll = (poll:PollProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/update`, { poll })
            dispatch({ type: V1_UPDATE_POLLS, polls: [ resp.data.poll ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_activatePoll = (poll_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/activate`, { poll_id })
            dispatch({ type: V1_UPDATE_POLLS, polls: [ resp.data.poll ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_closePoll = (poll_id:string, winning_option_id?:string, winning_value?:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/close`, { poll_id, winning_option_id, winning_value })
            dispatch({ type: V1_UPDATE_POLLS, polls: [ resp.data.poll ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_deletePoll = (poll_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/close`, { poll_id })
            dispatch({ type: V1_UPDATE_POLLS, polls: [ resp.data.poll ] })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_getLeadersByCampaignId = (poll_campaign_id:string, offset:number) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/leaders/campaign/${poll_campaign_id}?offset=${offset}`)
            //Before updating the ux - lets get the users
            let poll_campaign_leaders:PollCampaignLeaderProps[] = resp.data.poll_campaign_leaders;
            let player_ids = poll_campaign_leaders.map(l => l.player_id)
            await dispatch(player_getBulkPlayers(player_ids))
            dispatch({ type: V1_UPDATE_POLL_CAMPAIGN_LEADERS, poll_campaign_leaders: resp.data.poll_campaign_leaders })
        } catch (e) {
            console.log(e)
            errHandler(e)
        }
    }
}

export const poll_getPollsByCampaignId = (poll_campaign_id:string) => {
    return async(dispatch:any) => {
        try {
           const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/campaign/${poll_campaign_id}`)
           dispatch({ type: V1_UPDATE_POLLS, polls: resp.data.polls })
           dispatch({ type: V1_UPDATE_POLL_CAMPAIGN_GOALS, poll_campaign_goals:resp.data.poll_campaign_goals })
        } catch (e) {
            console.log(e)
        }
    }
}

/**
 * No Dispatch - returns the object directly
 * @param device_id 
 * @param player_id 
 * @returns poll response or udnefined
 */
export const poll_searchPollResponse = async(poll_id:string, device_id?:string|null, player_id?:string, phone?:string):Promise<PollResponseProps | undefined> => {
    try {
        const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/response/search/${poll_id}?device_id=${device_id}&player_id=${player_id}&phone=${phone}`)
        return resp.data.poll_response
    } catch (e) {
        console.log(e)
        return undefined
    }
    
}

export const poll_notifyPollResponders = (poll_campaign_ids:string[], player_notification:PlayerNotificationProps) => {
    return async(dispatch:any) => {
        try {
            await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/notify`, { poll_campaign_ids, player_notification })
            dispatch({ type: V1_LOAD_ALERT, alert: { title:'Success', type:'success', body:'Successfully notified users!' } })
        } catch (e) {
            console.log(e)
        }
    }
}

export const poll_getPollsByRelatedIdAndType = (related_type:string, related_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/related/${related_type}/${related_id}`)
            dispatch({ type:V1_UPDATE_POLLS, polls: resp.data.polls })
        } catch (e) {
            console.log(e)
        }
    }
}


export const poll_getPollById = (poll_id:string) => {
    return async(dispatch:any) => {
        try {
           const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/poll/${poll_id}`)
           dispatch({ type: V1_UPDATE_POLLS, polls: [resp.data.poll] })
           dispatch({ type: V1_UPDATE_POLL_OPTIONS, poll_options: resp.data.poll_options })
           dispatch({ type: V1_UPDATE_POLL_SUMMARIES, poll_summaries: resp.data.poll_summaries })
        } catch (e) {
            console.log(e)
        }
    }
}

/**
 * No dispatch - creates a new poll response
 * @param poll_response 
 * @returns 
 */
export const poll_createPollResponse = async(poll_response:PollResponseProps):Promise<PollResponseProps | undefined> => {
    try {
        const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/response/create`, { poll_response })
        return resp.data.poll_response
    } catch (e) {
        console.log(e)
        return undefined
    }
}



export const poll_createPollOption = (poll_option:PollOptionProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/option/create`, { poll_option })
            dispatch({ type: V1_UPDATE_POLL_OPTIONS, poll_options: [resp.data.poll_option] })
        } catch (e) {
            errHandler(e)
        }
    }
}

export const poll_updatePollOption = (poll_option:PollOptionProps) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/option/update`, { poll_option })
            dispatch({ type: V1_UPDATE_POLL_OPTIONS, poll_options: [resp.data.poll_option] })
        } catch (e) {
            errHandler(e)
        }
    }
}
